import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { companyMembersSelector } from "@store/members/members-selector";
import { fetchCompanyMembers } from "@store/members/members-slice-thunk";
import { canUseTeamsSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { fetchTeams } from "@store/teams/teams-slice-thunk";
import { useEffect } from "react";

/** Returns all the members in the company */
export function useCompanyMembers() {
  const $ = _c(6);
  const companyId = useCompanyId();
  const dispatch = useAppDispatch();
  const companyMembers = useAppSelector(companyMembersSelector);
  const canUseTeams = useAppSelector(canUseTeamsSelector);
  const {
    canFetchTeams
  } = useHasUserValidRoleCompanyLevel();
  let t0;
  let t1;
  if ($[0] !== canFetchTeams || $[1] !== canUseTeams || $[2] !== companyId || $[3] !== dispatch) {
    t0 = () => {
      const fetchCompanyMembersViaStore = async function fetchCompanyMembersViaStore() {
        await dispatch(fetchCompanyMembers({
          companyId
        }));
        canFetchTeams && canUseTeams && (await dispatch(fetchTeams({})));
      };
      fetchCompanyMembersViaStore();
    };
    t1 = [canFetchTeams, canUseTeams, companyId, dispatch];
    $[0] = canFetchTeams;
    $[1] = canUseTeams;
    $[2] = companyId;
    $[3] = dispatch;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  return companyMembers;
}